import { render, staticRenderFns } from "./EmptyDrafts.vue?vue&type=template&id=3cc82338&scoped=true"
import script from "./EmptyDrafts.vue?vue&type=script&lang=js"
export * from "./EmptyDrafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc82338",
  null
  
)

export default component.exports